module.exports = __webpack_public_path__ + "static/media/founder.b8ff0fef.JPG";